<template>
  <div class="absolute-table">
    <Table
      class="bordered-table"
      :size="size"
      :dataSource="data"
      :height="height"
      :columns="columns"
      v-bind="$attrs"
      v-on="$listeners"
      :pagination="pagination"
      :customRow="
        record => {
          return tableConfig(record);
        }
      "
    />
    <p class="table-bottom-label" v-if="pagination">
      Showing {{ data.length }} out of
      {{ showZero ? "0" : pagination.total }} Records
    </p>
  </div>
</template>

<script>
import { Table } from "ant-design-vue";

export default {
  components: {
    Table
  },
  props: {
    size: {
      type: String,
      default: "large"
    },
    data: {
      type: Array,
      required: true
    },
    height: {
      type: [Number, String],
      default: 100
    },
    columns: {
      type: Array,
      required: true
    },
    pagination: {
      type: Object,
      default: () => ({})
    },
    showZero: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleRowClick(rowData) {
      this.$emit("on-row-click", rowData);
    },
    tableConfig(record) {
      return {
        on: {
          click: event => this.handleRowClick(record),
          dblClick: event => {},
          mouseenter: event => {},
          mouseleave: event => {}
        }
      };
    }
  }
};
</script>

<style lang="scss">
.absolute-table {
  position: relative;
  .ant-table {
    overflow-x: scroll;
  }
  .table-bottom-label {
    position: absolute;
    bottom: 0;
    left: 17px;
    font-size: 12px;
    color: #cc2f2a;
  }
}
.ant-table-wrapper {
  .ant-pagination-item-active {
    border-color: #282d7f;
    a {
      color: #cc2f2a;
    }
  }
}

@media only screen and (max-width: 425px) {
  .absolute-table {
    .table-bottom-label {
      text-align: center;
      width: 100%;
      left: 0;
    }
  }
}
</style>
